var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { outlined: "" } },
    [
      _c(
        "v-card-text",
        [
          _vm.effectiveShowShiftTotals
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.shiftTotalsDisplay.total,
                          label: "CH Total",
                          filled: "",
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _vm.editableShiftTotals
                        ? _c("v-text-field", {
                            attrs: {
                              label: "CH Manhã",
                              filled: "",
                              disabled: _vm.disabled,
                              placeholder: "auto",
                              hint: "Deixe vazio para calcular automaticamente",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.manualCh.morning,
                              callback: function ($$v) {
                                _vm.$set(_vm.manualCh, "morning", $$v)
                              },
                              expression: "manualCh.morning",
                            },
                          })
                        : _c("v-text-field", {
                            attrs: {
                              value: _vm.shiftTotalsDisplay.morning,
                              label: "CH Manhã",
                              filled: "",
                              readonly: "",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _vm.editableShiftTotals
                        ? _c("v-text-field", {
                            attrs: {
                              label: "CH Tarde",
                              filled: "",
                              disabled: _vm.disabled,
                              placeholder: "auto",
                              hint: "Deixe vazio para calcular automaticamente",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.manualCh.evening,
                              callback: function ($$v) {
                                _vm.$set(_vm.manualCh, "evening", $$v)
                              },
                              expression: "manualCh.evening",
                            },
                          })
                        : _c("v-text-field", {
                            attrs: {
                              value: _vm.shiftTotalsDisplay.evening,
                              label: "CH Tarde",
                              filled: "",
                              readonly: "",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _vm.editableShiftTotals
                        ? _c("v-text-field", {
                            attrs: {
                              label: "CH Noite",
                              filled: "",
                              disabled: _vm.disabled,
                              placeholder: "auto",
                              hint: "Deixe vazio para calcular automaticamente",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.manualCh.night,
                              callback: function ($$v) {
                                _vm.$set(_vm.manualCh, "night", $$v)
                              },
                              expression: "manualCh.night",
                            },
                          })
                        : _c("v-text-field", {
                            attrs: {
                              value: _vm.shiftTotalsDisplay.night,
                              label: "CH Noite",
                              filled: "",
                              readonly: "",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.daysOfWeekOptions,
                      "item-text": "text",
                      "item-value": "id",
                      label: "Dia da semana",
                      filled: "",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.formModel.day_of_week_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.formModel, "day_of_week_id", $$v)
                      },
                      expression: "formModel.day_of_week_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6", sm: "2" } },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "00:00",
                        expression: "'00:00'",
                      },
                    ],
                    attrs: {
                      label: "Início (HH:mm)",
                      filled: "",
                      placeholder: "HH:mm",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.formModel.hour_start,
                      callback: function ($$v) {
                        _vm.$set(_vm.formModel, "hour_start", $$v)
                      },
                      expression: "formModel.hour_start",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6", sm: "2" } },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "00:00",
                        expression: "'00:00'",
                      },
                    ],
                    attrs: {
                      label: "Fim (HH:mm)",
                      filled: "",
                      placeholder: "HH:mm",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.formModel.hour_end,
                      callback: function ($$v) {
                        _vm.$set(_vm.formModel, "hour_end", $$v)
                      },
                      expression: "formModel.hour_end",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.availabilityTypeOptions,
                      "item-text": "text",
                      "item-value": "id",
                      label: "Tipo",
                      filled: "",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.formModel.availability_type_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.formModel, "availability_type_id", $$v)
                      },
                      expression: "formModel.availability_type_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: "primary",
                        "x-small": "",
                        disabled: _vm.disabled,
                      },
                      on: { click: _vm.onAddOrUpdate },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", "x-small": "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.isEditing ? "mdi-content-save" : "mdi-plus"
                          )
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.isEditing ? "Atualizar" : "Adicionar") +
                          " "
                      ),
                    ],
                    1
                  ),
                  _vm.isEditing
                    ? _c(
                        "v-btn",
                        {
                          attrs: { text: "", "x-small": "" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("Cancelar")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.orderedItems.length
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: { dense: "", outlined: "", type: "info" },
                },
                [_vm._v(" Nenhuma faixa personalizada adicionada. ")]
              )
            : _vm._e(),
          _vm.effectiveShowByCampuses
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.campusOptions,
                          "item-text": "text",
                          "item-value": "id",
                          label: "Campi",
                          filled: "",
                          multiple: "",
                          chips: "",
                          disabled: _vm.disabled,
                        },
                        model: {
                          value: _vm.formModel.campuses,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "campuses", $$v)
                          },
                          expression: "formModel.campuses",
                        },
                      }),
                      _c(
                        "small",
                        { staticClass: "grey--text text--darken-1" },
                        [
                          _vm._v(
                            " Campi não particionam a validação de sobreposição; o bloqueio é sempre por dia. "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("v-divider", { staticClass: "my-3" }),
          _vm.orderedItems.length
            ? _c("v-simple-table", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Dia"),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Início"),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Fim"),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Tipo"),
                              ]),
                              _vm.effectiveShowByCampuses
                                ? _c("th", { staticClass: "text-left" }, [
                                    _vm._v("Campi"),
                                  ])
                                : _vm._e(),
                              _c("th", { staticClass: "text-right" }, [
                                _vm._v("Ações"),
                              ]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.orderedItems, function (item) {
                              return _c("tr", { key: item.__index }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        _vm.daysOfWeekOptions.find(
                                          (d) => d.id === item.day_of_week_id
                                        ) || {}
                                      ).text
                                    )
                                  ),
                                ]),
                                _c("td", [_vm._v(_vm._s(item.hour_start))]),
                                _c("td", [_vm._v(_vm._s(item.hour_end))]),
                                _c("td", [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: _vm.getColorFn(
                                              item.availability_type_id
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getIconFn(
                                                item.availability_type_id
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (
                                              _vm.availabilityTypeOptions.find(
                                                (t) =>
                                                  t.id ===
                                                  item.availability_type_id
                                              ) || {}
                                            ).text
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm.effectiveShowByCampuses
                                  ? _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (item.campuses || [])
                                              .map(
                                                (id) =>
                                                  (
                                                    _vm.campusesEffective.find(
                                                      (c) => c.id === id
                                                    ) || {}
                                                  ).initials
                                              )
                                              .filter(Boolean)
                                              .join(", ")
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "td",
                                  { staticClass: "text-right" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.edit(item.__index)
                                          },
                                        },
                                      },
                                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "error",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove(item.__index)
                                          },
                                        },
                                      },
                                      [_c("v-icon", [_vm._v("mdi-delete")])],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1864939111
                ),
              })
            : _vm._e(),
          _vm.effectiveShowSave
            ? _c("v-divider", { staticClass: "my-3" })
            : _vm._e(),
          _vm.effectiveShowSave
            ? _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        dark: "",
                        small: "",
                        disabled: _vm.disabled || _vm.saving,
                      },
                      on: { click: _vm.save },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", dark: "" } }, [
                        _vm._v("save"),
                      ]),
                      _vm._v(" Salvar "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-snackbar",
            {
              attrs: { timeout: 20000, color: _vm.snackbarColor, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }